export enum WithdrawalOptionType {
  Charity = 'charity',
  MerchantCard = 'merchant_card',
  VisaCard = 'visa_card',
  Paypal = 'paypal',
  Venmo = 'venmo',
}
